import React from 'react'

import glasses from '../../../assets/svg/glasses.svg'
import flamingo from '../../../assets/svg/flamingo2.svg'
import lamp from '../../../assets/svg/lamp.svg'
import globe from '../../../assets/svg/globe.svg'
import tottenham from '../../../assets/svg/tottenham.svg'
import basketball from '../../../assets/svg/basketball.svg'
import guitar from '../../../assets/svg/guitar2.svg'
import cactus from '../../../assets/svg/cactus2.svg'
import {
  HeroVisual,
  HeroArtFrame,
  HeroSlabs,
  HeroSlab,
  HeroObjects,
  HeroObject,
  TottenhamSlot,
  BallSlot,
  Glasses,
  Flamingo,
  Lamp,
  Globe,
  TottenhamAndBall,
  Tottenham,
  Ball,
  Guitar,
  Cactus
} from './HeroArtStyledComponents'

const HeroArt = () => (
  <HeroVisual>
    <HeroArtFrame>
      <HeroSlabs aria-hidden="true">
        <HeroSlab $tone="yellow" />
        <HeroSlab $tone="teal" />
        <HeroSlab $tone="pink" />
      </HeroSlabs>
      <HeroObjects>
        <HeroObject $flex={71} $transform="translateY(8px)">
          <Glasses src={glasses} alt="" />
        </HeroObject>
        <HeroObject $flex={107} $transform="scale(1.1)">
          <Flamingo src={flamingo} alt="" />
        </HeroObject>
        <HeroObject $flex={48} $transform="rotate(-4deg)">
          <Lamp src={lamp} alt="" />
        </HeroObject>
        <HeroObject $flex={68} $transform="rotate(15deg)">
          <Globe src={globe} alt="" />
        </HeroObject>
        <TottenhamAndBall>
          <TottenhamSlot>
            <Tottenham src={tottenham} alt="" />
          </TottenhamSlot>
          <BallSlot>
            <Ball src={basketball} alt="" />
          </BallSlot>
        </TottenhamAndBall>
        <HeroObject $flex={89} $shift="-1.75rem" $transform="scale(1.1) rotate(-4deg)">
          <Guitar src={guitar} alt="" />
        </HeroObject>
        <HeroObject $flex={83} $shift="-2.25rem" $transform="rotate(10deg)">
          <Cactus src={cactus} alt="" />
        </HeroObject>
      </HeroObjects>
    </HeroArtFrame>
  </HeroVisual>
)

HeroArt.displayName = 'HeroArt'

export default HeroArt
